var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "url(#pattern0_2036_94048)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2036_94048",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2036_94048",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2036_94048",
    width: 48,
    height: 48,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAABTklEQVRoBe2YUYrCQAyGq7CL3sEDbdnTKOjjost6M8/gg/ikHkJFWPMrU2JpI4TgWPgHYuNkkvnnS186RcFBAiRAAiRAAo8EhvJ3IbYVu4j9ZzZogJa5GLSZAwtWYrlFt+0PbQPrBCDflvwu8z/WAdCqJHQq/oe1uCV2UjVSrfQ8tuRY09AwUzU31mL9zn9aC43YUmJNh8Dcn5FnhaAlQYDGavQq7+5gURr1WJrP9WzU1s+lJmpfHiCKpLcOO+AlF5XHDkSR9NZhB7zkovLYgSiS3jrsgJdcVB47EEXSW4cd8JKLymMHokh669Q7cFaFvB/1qkSYq7VojUX9AGu15Vh8nahCL3WhYaJ21Bpv09/yexBL1xbeJy7Fnt0jIf4bsBc07sVKXJ3AGYl1cezrr1AXD1GUohpd8L46ufJ2ovmrk8QpmgRIgARIgAQSgSveueuTdwtHJAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcIcon);
export default __webpack_public_path__ + "static/media/PCIcon.664306812bdca2f682e3d6ef146c3e24.svg";
export { ForwardRef as ReactComponent };